import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useToast } from "../comman/CustomMessages";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Input,
  InputAdornment,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Chip,
  FormHelperText,
  Tooltip,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  ADD_UPDATE_BROKER_URL,
  GET_COUNTY_LIST_BY_STATE_URL,
  GET_PROJECT_BROKER_DETAILS_BY_ID_URL,
  USERS_BY_ID_URL,
} from "../../constants/ApiRoute";
import { authHeader, getLogUserId } from "../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import API from "../comman/API";
import { getAlluserList } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { stateData } from "../comman/Constant";
import CustomPageLoading from "../comman/CustomPageLoading";
import CustomLoader from "../comman/CustomLoader";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const dayRateOptions = [
  { value: "principalRate", label: "Principal Rate", apiField: "isPrincipalRate" },
  {
    value: "projectManagerRate",
    label: "Project Manager Rate",
    apiField: "isProjectManagerRate",
  },
  { value: "fieldAgentRate", label: "Field Agent Rate", apiField: "isFieldAgentRate" },
];

const isSelectedRate = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

const initialValues = {
  brokerId: 0,
  userId: 0,
  country: "United States of America",
  state: 0,
  county: "Select county",
  defaultLocationId: 0,
  lead: null,
  selectedDayRates: [],
  dayRate: "",
  PayablePerDiem: "",
  payableOfficePerDiem: "",
  payableTravelPerDiem: "",
  active: true,
};
export default function AddEditBroker(props) {
  const {
    open,
    handleClose,
    id,
    brokerRowDetailValue,
    locationList,
    projectDetailValue,
  } = props;
  const showToast = useToast();
  const dispatch = useDispatch();
  const userListSel = deCryptFun(useSelector((s) => s.AllUserReducer));
  const filteredBrokerList = userListSel
    ? JSON.parse(userListSel).data.filter(
        (userlist) =>
          userlist.UserRole &&
          userlist.UserRole.split(",").includes(
            "6d8f5f3c-8ed1-40d5-b870-d54283c7da28"
          )
      )
    : [];
  const stateList = deCryptFun(useSelector((s) => s.AllStateListReducer));
  const filteredStateList = JSON.parse(stateList).data.filter((state) =>
    locationList.some(
      (location) => parseInt(location.State) == parseInt(state.countyId)
    )
  );
  const theme = useTheme();
  const [countyList, setCountyList] = useState([]);
  console.log(countyList, "countyyyyyyy");
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const validationSchema = Yup.object({
    userId: Yup.string().test(
      "broker",
      "Broker name is required",
      (value) => value != 0
    ),
    county: Yup.string().test(
      "county",
      "County is required",
      (value) => value != "Select county"
    ),
    dayRate: Yup.number()
      .required("Day Rate is required")
      .typeError("Day Rate should be a number"),
    payableOfficePerDiem: Yup.number()
      .required("Office per diem is required")
      .typeError("Office per diem should be a number"),
    payableTravelPerDiem: Yup.number()
      .required("Travel per diem is required")
      .typeError("Travel per diem should be a number"),
    state: Yup.string().test(
      "state",
      "State is required",
      (value) => value != 0
    ),
    country: Yup.string().required("Country is required"),
    lead: Yup.boolean().required("Lead is required"),
  });

  const {
    handleSubmit,
    handleChange,
    setValues,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
    handleBlur,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      await AddUpdatebrokerFun(values);
    },
  });
  console.log(values, "6d8f5f3c-8ed1-40d5-b870-d54283c7da28vvvvvjauay");
  const AddUpdatebrokerFun = async (values) => {
    setButtonLoading(true);

    // const responseUser = await getUserByDetails(values.userId);
    // if (responseUser === true) {
    //   return false;
    // }

    const {
      brokerId,
      userId,
      state,
      country,
      county,
      defaultLocationId,
      lead,
      selectedDayRates,
      dayRate,
      PayablePerDiem,
      payableOfficePerDiem,
      payableTravelPerDiem,
      active,
    } = values;
    let countyName = "";
    let cn = countyList && countyList.filter((r) => r.ID == county);
    let locationId =
      locationList && locationList.filter((r) => r.LocationID == county);
    if (cn) {
      countyName = cn[0]?.County;
    }
    console.log("name", countyName);
    let d1 = {
      projectId: id ? id : 0,
      brokerId,
      userId,
      state: state ? Number(state) : 0,
      country,
      county: countyName,
      // defaultLocationId: locationId[0]?.LocationID,
      defaultLocationId: county,
      lead: lead ? true : false,
      isPrincipalRate: lead
        ? selectedDayRates.includes("principalRate")
        : false,
      isProjectManagerRate: lead
        ? selectedDayRates.includes("projectManagerRate")
        : false,
      isFieldAgentRate: lead
        ? selectedDayRates.includes("fieldAgentRate")
        : false,
      dayRate: dayRate ? dayRate : 0,
      payableOfficePerDiem: payableOfficePerDiem
        ? Number(payableOfficePerDiem)
        : 0,
      payableTravelPerDiem: payableTravelPerDiem
        ? Number(payableTravelPerDiem)
        : 0,
      active,
    };

    const config = {
      method: "POST",
      url: ADD_UPDATE_BROKER_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(d1)),
        flutterString: "",
      },
    };
    setButtonLoading(true);
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        let updatedBrokerName = "";
        if (brokerRowDetailValue.BrokerID) {
          let updatedBrokerFirstName =
            brokerRowDetailValue.FirstName.charAt(0).toUpperCase() +
            brokerRowDetailValue.FirstName.slice(1).toLowerCase();
          let updatedBrokerLastName =
            brokerRowDetailValue.LastName.charAt(0).toUpperCase() +
            brokerRowDetailValue.LastName.slice(1).toLowerCase();
          updatedBrokerName =
            updatedBrokerFirstName + " " + updatedBrokerLastName;
        }
        setButtonLoading(false);
        showToast(parsedResponse.message, "success", true);
        handleClose();
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        setButtonLoading(false);
        showToast(v.message, "error", true);
        handleClose();
      }
    } finally {
      resetForm();
      // setFlag(true);
    }
  };

  const getUserByDetails = async (userId) => {
    const config = {
      method: "GET",
      url: USERS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify({ userId: userId })),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        const { FirstName, LastName, Email, AccountActive } =
          parsedResponse.data[0];

        if (!AccountActive) {
          dispatch(getAlluserList());
          showToast(
            `${FirstName} ${LastName} ( ${Email} ) account is currently inactive`,
            "error"
          );
          setValues({ ...values, userId: 0 });
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (error) {}
  };

  const handleChangeLeadStatus = (status) => {
    setValues({
      ...values,
      lead: status == "yes" ? 1 : 0,
      selectedDayRates: status == "yes" ? values.selectedDayRates : [],
    });
  };

  const handleChangeDayRates = (event) => {
    const selected = event.target.value;
    setValues({
      ...values,
      selectedDayRates: typeof selected === "string" ? selected.split(",") : selected,
    });
  };

  useEffect(() => {
    dispatch(getAlluserList());
  }, []);

  useEffect(() => {
    if (brokerRowDetailValue.BrokerID) {
      setLoading(true);
      countyLoad(brokerRowDetailValue.State ? brokerRowDetailValue.State : "");
      console.log(brokerRowDetailValue, "brokerRowDetailValue");
      setValues((prevValues) => ({
        ...prevValues,

        brokerId:
          brokerRowDetailValue.BrokerID && brokerRowDetailValue.BrokerID,
        userId: brokerRowDetailValue.UserID ? brokerRowDetailValue.UserID : "",
        country: brokerRowDetailValue.Country
          ? brokerRowDetailValue.Country
          : "",
        state: brokerRowDetailValue.State ? brokerRowDetailValue.State : "",
        county: brokerRowDetailValue.DefaultLocationID
          ? brokerRowDetailValue.DefaultLocationID
          : "",
        defaultLocationId: brokerRowDetailValue.DefaultLocationID,
        lead: brokerRowDetailValue.Lead ? true : false,
        selectedDayRates: dayRateOptions
          .filter((option) =>
            isSelectedRate(
              brokerRowDetailValue[option.apiField] ??
                brokerRowDetailValue[
                  option.apiField.charAt(0).toUpperCase() + option.apiField.slice(1)
                ]
            )
          )
          .map((option) => option.value),
        dayRate:!isNaN(parseFloat(brokerRowDetailValue.DayRate))
        ? parseFloat(brokerRowDetailValue.DayRate.toFixed(2))
        : "0.00",
        payableOfficePerDiem: !isNaN(parseFloat(brokerRowDetailValue.PayableOfficePerDiem))
        ? parseFloat(brokerRowDetailValue.PayableOfficePerDiem).toFixed(2)
        : "0.00",
      payableTravelPerDiem: !isNaN(parseFloat(brokerRowDetailValue.PayableTravelPerDiem))
        ? parseFloat(brokerRowDetailValue.PayableTravelPerDiem).toFixed(2)
        : "0.00",
      
        // ? brokerRowDetailValue.PayableTravelPerDiem
        // : "",
        active: brokerRowDetailValue.Active ? true : false,
      }));
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
    dispatch(getAlluserList());
  }, [brokerRowDetailValue]);

  const handleChangeState = async (e) => {
    handleChange(e);
    let postData = {
      projectId: id,
      stateId: e.target.value,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_COUNTY_LIST_BY_STATE_URL,
      params: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
       
        setValues((prevValues) => ({
          ...prevValues,
          county: "Select county"
        }));

        setCountyList(parsedResponse.locationDetails);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const countyLoad = async (stateValue) => {
    let postData = {
      projectId: id,
      stateId: stateValue,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_COUNTY_LIST_BY_STATE_URL,
      params: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        setCountyList(parsedResponse.locationDetails);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getBrokerDetails = async (e) => {
    let postData = {
      brokerUserId: brokerId,
    };
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_PROJECT_BROKER_DETAILS_BY_ID_URL,
      params: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        // setCountyList(parsedResponse.locationDetails);
        console.log("details", parsedResponse.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    // getBrokerDetails()
  }, []);

  // const handleNumericChange = (e) => {
  //   const { value } = e.target;
  //   if (/^\d*\.?\d*$/.test(value)) {
  //     handleChange(e);
  //   }
  // };

  const handleNumericChange = (event) => {
    const { name, value } = event.target;
    const sanitizedValue = value.replace(/[^\d.]/g, "");
    if ((sanitizedValue.match(/\./g) || []).length > 1) {
      return;
    }

    if (/^0[0-9]+/.test(sanitizedValue)) {
      const correctedValue = sanitizedValue.replace(/^0+/, "");
      setValues({ ...values, [name]: correctedValue });
      return;
    }

    const decimalParts = sanitizedValue.split(".");
    if (decimalParts[1] && decimalParts[1].length > 2) {
      return;
    }

    setValues({ ...values, [name]: sanitizedValue });
  };

  // const handleCustomBlur = (e) => {
  //   const { name, value } = e.target;
  //   // if (value != initialValues1[name] && value != initialValues[name] && !toastShown) {
  //   if (name === "dayRate" && projectDetailValue.BillingDayRate < value) {
  //     showToast(
  //       "Payable day rate is more than the project's day rate",
  //       "warning",
  //       true,
  //       { autoClose: 5000 }
  //     );
  //   } else if (
  //     name === "payableOfficePerDiem" &&
  //     projectDetailValue.BillableOfficePerDiem < value
  //   ) {
  //     showToast(
  //       "Payable office per diem is more than the project's office per diem",
  //       "warning",
  //       true,
  //       { autoClose: 5000 }
  //     );
  //     // setInitialValues1((prevValues)=>({
  //     //   ...prevValues,
  //     //   payableOfficePerDiem: value
  //     // }))
  //   } else if (
  //     name === "payableTravelPerDiem" &&
  //     projectDetailValue.BillableTravelPerDiem < value
  //   ) {
  //     showToast(
  //       "Payable travel per diem is more than the project's travel per diem",
  //       "warning",
  //       true,
  //       { autoClose: 5000 }
  //     );
  //     // setInitialValues1((prevValues)=>({
  //     //   ...prevValues,
  //     //   payableTravelPerDiem: value
  //     // }))
  //   }
  //   // }

  //   // Call Formik's handleBlur if no warning was shown
  //   handleBlur(e);
  // };

  // Update initial values when form values change
  // useEffect(() => {
  //   setInitialValues1({
  //   dayRate: brokerRowDetailValue.DayRate,
  //   payableOfficePerDiem: brokerRowDetailValue.PayableOfficePerDiem,
  //   payableTravelPerDiem: brokerRowDetailValue.PayableTravelPerDiem,
  //   });
  // }, [
  //   brokerRowDetailValue.DayRate,
  //   brokerRowDetailValue.PayableOfficePerDiem,
  //   brokerRowDetailValue.PayableTravelPerDiem,
  // ]);

  return (
    <>
      <Dialog
        className="user-filter-popup cst-filter broker-map-popup"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        aria-labelledby="responsive-dialog-title"
        component={"form"}
        onSubmit={handleSubmit}
      >
        {loading && <CustomPageLoading />}
        <Stack
          sx={{ p: "25px 34px" }}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography className="model-title">
            {values && values.brokerId
              ? "Edit Broker Mapping"
              : "Add Broker Mapping"}
          </Typography>
        </Stack>
        <Box className="add-broker-map" sx={{ p: "0px 34px 0px 34px" }}>
          <Stack
            sx={{ p: "0px 15px 0px 0px" }}
            direction={{ xs: "column", sm: "row", md: "row" }}
            alignItems={{ xs: "flex-end", sm: "baseline", md: "baseline" }}
            justifyContent="space-between"
            spacing={3}
          >
            <FormControl
              sx={{ width: "100%" }}
              variant="outlined"
              disabled={values && values.brokerId}
            >
              <p className="label">
                Available Brokers:
                <Tooltip
                  className="project-tooltip"
                  title="Available brokers are all active users with the 'Broker' role. This is managed in 'Manage Users' above."
                  arrow
                  placement="top"
                >
                  <IconButton sx={{ p: 0 }}>
                    <HelpOutlineIcon
                      sx={{ width: "25px", height: "15px", ml: "3px" }}
                    />
                    {/* <img src="path/to/question-mark.png" alt="info" style={{ width: '20px', height: '20px' }} /> */}
                  </IconButton>
                </Tooltip>
              </p>
              <Select
                className="edit-broker-map"
                sx={{
                  ".MuiSelect-select": {
                    color:
                      values.userId === 0
                        ? "#898989 !important"
                        : "#212121 !important",
                  },
                }}
                name="userId"
                value={values.userId}
                onChange={handleChange}
                IconComponent={KeyboardArrowDownIcon}
                error={Boolean(errors.userId && touched.userId)}
                helperText={
                  errors.userId && touched.userId ? errors.userId : ""
                }
              >
                <MenuItem selected disabled value={0}>
                  Select Broker
                </MenuItem>
                {filteredBrokerList &&
  filteredBrokerList
    .filter((item) => item.AccountActive === 1) // Filter brokers with AccountActive === 1
    .sort((a, b) => {
      const nameA = `${a.FirstName} ${a.LastName}`;
      const nameB = `${b.FirstName} ${b.LastName}`;

      // Step 1: Compare by first letter alphabetically (case-insensitive)
      const firstCharA = nameA[0].toLowerCase();
      const firstCharB = nameB[0].toLowerCase();

      if (firstCharA !== firstCharB) {
        return firstCharA.localeCompare(firstCharB); // Alphabetical order by first letter
      }

      // Step 2: If the first letters are the same, prioritize uppercase over lowercase
      const isUpperCaseA = nameA[0] === nameA[0].toUpperCase();
      const isUpperCaseB = nameB[0] === nameB[0].toUpperCase();

      if (isUpperCaseA !== isUpperCaseB) {
        return isUpperCaseA ? -1 : 1; // Uppercase comes before lowercase
      }

      // Step 3: If both are the same case, sort alphabetically
      return nameA.localeCompare(nameB);
    })
    .map((item) => {
      return (
        <MenuItem
          key={item.UserId}
          value={item.UserId}
          sx={{
            color: item.AccountActive === 1 ? "#212121" : "#888",
          }} // Use color based on AccountActive
          disabled={item.AccountActive !== 1} // Disable selection if not active
        >
          <span className="billing-select-option">
            {item.FirstName + " " + item.LastName}
          </span>
        </MenuItem>
      );
    })}


                {/* {filteredBrokerList &&
                  filteredBrokerList.map((item) => {
                    const isInactive = item.AccountActive; 
                    console.log(isInactive,'isInactiveisInactive')// Check if broker is inactive
                    return (
                      <MenuItem
                        key={isInactive.UserId}
                        value={isInactive.UserId}
                        sx={{ color: isInactive ? "#888" : "#212121" }} // Grayout inactive brokers
                        disabled={isInactive} // Disable selection of inactive brokers
                      >
                        <span className="billing-select-option">
                          {isInactive.FirstName + " " + isInactive.LastName} */}
                {/* {isInactive && " (Inactive)"}{" "} */}
                {/* Label as Inactive */}
                {/* </span>
                      </MenuItem>
                    );
                  })} */}
              </Select>

              <FormHelperText error={true}>
                {errors.userId && touched.userId ? errors.userId : ""}
              </FormHelperText>
            </FormControl>

            <FormControl sx={{ width: "100%" }} variant="standard">
              <p className="label">Country:</p>
              <Input
                name="country"
                id="country"
                disabled
                value={values.country}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <KeyboardArrowDownIcon />
                    </InputAdornment>
                  ),
                }}
                placeholder="Enter Country"
                onChange={handleChange}
                error={errors.country && touched.country}
                helperText={
                  errors.country && touched.country ? errors.country : ""
                }
              />
              <FormHelperText error={true}>
                {errors.country && touched.country ? errors.country : ""}
              </FormHelperText>
            </FormControl>

            <FormControl sx={{ width: "100%" }} variant="outlined">
              <p className="label">State:</p>
              <Select
                sx={{
                  ".MuiSelect-select": {
                    color:
                      values.state === 0
                        ? "#898989 !important"
                        : "#212121 !important",
                  },
                  height: "40px",
                }}
                name="state"
                value={values.state}
                onChange={handleChangeState}
                IconComponent={KeyboardArrowDownIcon}
                error={errors.state && touched.state}
                helperText={errors.state && touched.state ? errors.state : ""}
              >
                {/* {locationList&&locationList.map((r)=>{
                  return(
                    <MenuItem value={}></MenuItem>
                  )
                })} */}
                <MenuItem selected={true} disabled={true} value={0}>
                  Select State:
                </MenuItem>
                {filteredStateList &&
                  filteredStateList.map((item) => (
                    <MenuItem key={item.countyId} value={item.countyId}>
                      {item.name}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText error={true}>
                {errors.state && touched.state ? errors.state : ""}
              </FormHelperText>
            </FormControl>
          </Stack>
          <Stack
            sx={{ p: "0px 15px 0px 0px" }}
            direction={{ xs: "column", sm: "row", md: "row" }}
            alignItems={{ xs: "flex-end", sm: "baseline", md: "baseline" }}
            justifyContent="space-between"
            spacing={3}
          >
            <FormControl sx={{ width: "100%" }} variant="standard">
              <p className="label">County:</p>
              <Select
                sx={{
                  p: "0px !important",
                  ".MuiSelect-select": {
                    color:
                      values.county == 0 ||
                      values.county == "Select county" ||
                      values.county == ""
                        ? "#898989 !important"
                        : "#212121 !important",
                  },
                }}
                name="county"
                id="county"
                value={values.county}
                IconComponent={KeyboardArrowDownIcon}
                // placeholder="Enter County"
                onChange={handleChange}
                error={errors.county && touched.county}
                helperText={
                  errors.county && touched.county ? errors.county : ""
                }
              >
                {console.log("countyList", countyList)}
                <MenuItem
                  selected={true}
                  // disabled={true}
                  value={"Select county"}
                >
                  Select County
                </MenuItem>
                {countyList &&
                  countyList.map((item) => (
                    <MenuItem key={item.ID} value={item.ID}>
                      {item.County}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText error={true}>
                {errors.county && touched.county ? errors.county : ""}
              </FormHelperText>
            </FormControl>
            <FormControl
              sx={{ width: "100%" }}
              variant="standard"
              className={
                projectDetailValue.BillingDayRate < values.dayRate &&
                !errors.dayRate
                  ? "email-not-confirm"
                  : ""
              }
            >
              <p className="label">Payable Day Rate:</p>
              <Input
                className="dollar-field"
                name="dayRate"
                id="dayRate"
                value={values.dayRate}
                placeholder="Enter Payable Day Rate"
                onChange={handleNumericChange}
                // onBlur={handleCustomBlur}
                error={errors.dayRate && touched.dayRate}
                helperText={
                  errors.dayRate && touched.dayRate ? errors.dayRate : ""
                }
                startAdornment={
                  <InputAdornment position="start">
                    <span className="dollar-icon">$</span>
                  </InputAdornment>
                }
              />
              <FormHelperText>
                {projectDetailValue.BillingDayRate < values.dayRate &&
                !errors.dayRate ? (
                  <span style={{ color: "#FFCC00", fontSize: '11px' }}>
                    Payable day rate is more than the project's day rate.
                  </span>
                ) : (
                  ""
                )}
              </FormHelperText>
              <FormHelperText error={true}>
                {errors.dayRate && touched.dayRate ? errors.dayRate : ""}
              </FormHelperText>
            </FormControl>

            <FormControl
              sx={{ width: "100%" }}
              variant="standard"
              className={
                projectDetailValue.BillableOfficePerDiem <
                  values.payableOfficePerDiem && !errors.payableOfficePerDiem
                  ? "email-not-confirm"
                  : ""
              }
            >
              <p className="label">Payable Office Per Diem:</p>
              <Input
                className="dollar-field"
                name="payableOfficePerDiem"
                id="payableOfficePerDiem"
                value={values.payableOfficePerDiem}
                placeholder="Enter Payable Office Per Diem"
                onChange={handleNumericChange}
                // onBlur={handleCustomBlur}
                error={
                  errors.payableOfficePerDiem && touched.payableOfficePerDiem
                }
                helperText={
                  errors.payableOfficePerDiem && touched.payableOfficePerDiem
                    ? errors.payableOfficePerDiem
                    : ""
                }
                startAdornment={
                  <InputAdornment position="start">
                    <span className="dollar-icon">$</span>
                  </InputAdornment>
                }
              />
              <FormHelperText>
                {projectDetailValue.BillableOfficePerDiem < values.payableOfficePerDiem ? (
                  <span style={{ color: "#FFCC00", fontSize: '11px' }}>
                    Payable office per diem is more than the project's office
                    per diem.
                  </span>
                ) : (
                  ""
                )}
              </FormHelperText>
              <FormHelperText error={true}>
                {errors.payableOfficePerDiem && touched.payableOfficePerDiem
                  ? errors.payableOfficePerDiem
                  : ""}
              </FormHelperText>
            </FormControl>
          </Stack>
          <Stack
            sx={{ p: "0px 15px 0px 0px", maxWidth: "310px" }}
            direction={{ xs: "column", sm: "row", md: "row" }}
            alignItems={{ xs: "flex-end", sm: "center", md: "center" }}
            justifyContent="space-between"
            spacing={3}
          >
            <FormControl
              variant="standard"
              className={
                projectDetailValue.BillableTravelPerDiem <
                  values.payableTravelPerDiem && !errors.payableTravelPerDiem
                  ? "email-not-confirm"
                  : ""
              }
            >
              <p className="label">Payable Travel Per Diem:</p>
              <Input
                className="dollar-field"
                name="payableTravelPerDiem"
                id="payableTravelPerDiem"
                value={values.payableTravelPerDiem}
                placeholder="Enter Payable Travel Per Diem"
                onChange={handleNumericChange}
                // onBlur={handleCustomBlur}
                error={
                  errors.payableTravelPerDiem && touched.payableTravelPerDiem
                }
                helperText={
                  errors.payableTravelPerDiem && touched.payableTravelPerDiem
                    ? errors.payableTravelPerDiem
                    : ""
                }
                startAdornment={
                  <InputAdornment position="start">
                    <span className="dollar-icon">$</span>
                  </InputAdornment>
                }
              />
              <FormHelperText>
                {projectDetailValue.BillableTravelPerDiem < values.payableTravelPerDiem &&
                !errors.payableTravelPerDiem ? (
                  <span style={{ color: "#FFCC00", fontSize: '11px' }}>
                    Payable travel per diem is more than the project's travel per diem.
                  </span>
                ) : (
                  ""
                )}
              </FormHelperText>
              <FormHelperText error={true}>
                {errors.payableTravelPerDiem && touched.payableTravelPerDiem
                  ? errors.payableTravelPerDiem
                  : ""}
              </FormHelperText>
            </FormControl>
          </Stack>
          <Stack
            sx={{ p: "0px 195px 0px 0px" }}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={3}
          >
            <Box sx={{ mt: { xs: "10px !important", sm: "0px !important" } }}>
              <p style={{ marginBottom: "0px" }} className="label">
                Lead:
              </p>
              <Stack
                sx={{ mb: "20px" }}
                direction="row"
                alignItems="center"
                justifyContent="flex-start"
                spacing={2}
              >
                <FormControlLabel
                  className="checkbox"
                  control={
                    <Checkbox
                      name="Lead"
                      id="Lead"
                      onChange={() => handleChangeLeadStatus("yes")}
                      checked={values.lead == 1}
                      // disabled={editFlag}
                      sx={{ color: "gray" }}
                    />
                  }
                  label="Yes"
                />

                <FormControlLabel
                  className="checkbox"
                  control={
                    <Checkbox
                      name="UserStatus"
                      id="UserStatusNo"
                      // disabled={editFlag}
                      onChange={() => handleChangeLeadStatus("no")}
                      checked={values.lead == 0}
                      sx={{ color: "gray" }}
                    />
                  }
                  label="No"
                />
                <FormHelperText
                  sx={{
                    position: "absolute",
                    mt: "44px !important",
                    ml: "2px !important",
                  }}
                  error={true}
                >
                  {errors.lead && touched.lead ? errors.lead : ""}
                </FormHelperText>
              </Stack>
            </Box>
          </Stack>
          {values.lead == 1 && (
            <Stack
              sx={{ p: "0px 195px 20px 0px" }}
              direction="row"
              alignItems="center"
            >
              <FormControl variant="standard" sx={{ width: "100%", maxWidth: "450px" }}>
                <p className="label">Select day rate:</p>
                <Select
                  sx={{
                    ".MuiSelect-select": {
                      minHeight: "40px !important",
                      height: "40px",
                      boxSizing: "border-box",
                      display: "flex",
                      alignItems: "center",
                      overflow: "hidden",
                      paddingTop: "8px !important",
                      paddingBottom: "8px !important",
                    },
                  }}
                  multiple
                  displayEmpty
                  name="selectedDayRates"
                  value={values.selectedDayRates || []}
                  onChange={handleChangeDayRates}
                  input={<OutlinedInput />}
                  IconComponent={KeyboardArrowDownIcon}
                  renderValue={(selected) => {
                    if (!selected.length) {
                      return <span style={{ color: "#898989" }}>Select day rate</span>;
                    }

                    return (
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "nowrap",
                          gap: 0.5,
                          overflow: "hidden",
                        }}
                      >
                        {selected.map((rate) => (
                          <Chip
                            key={rate}
                            label={dayRateOptions.find((option) => option.value === rate)?.label}
                            size="small"
                          />
                        ))}
                      </Box>
                    );
                  }}
                  MenuProps={MenuProps}
                >
                  {dayRateOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      <Checkbox checked={(values.selectedDayRates || []).includes(option.value)} />
                      <ListItemText primary={option.label} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          )}
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "26px 34px", pt: "0px" }}
        >
          <Button
            className={
              loading || buttonLoading ? "disable-filter-btn" : "filter-btn"
            }
            type="submit"
            disabled={loading || buttonLoading}
          >
            {loading ||
              (buttonLoading && (
                <CircularProgress
                  color={"inherit"}
                  size={10}
                  sx={{ marginRight: "3px" }}
                />
              ))}
            Save
          </Button>
          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
